import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=5330f3b4&scoped=true"
import script from "./agreement.vue?vue&type=script&lang=js"
export * from "./agreement.vue?vue&type=script&lang=js"
import style0 from "./agreement.vue?vue&type=style&index=0&id=5330f3b4&prod&scoped=true&lang=less"
import style1 from "./agreement.vue?vue&type=style&index=1&id=5330f3b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5330f3b4",
  null
  
)

export default component.exports